import utils from 'utils'
class smallScaleReportQueryCtrl {
  constructor(
    $scope,
    httpRequest,
    $state,
    $stateParams,
    sweetalert,
    logger,
    initSortService,
    $timeout,
    authService,
    $filter,
    Upload,
    $uibModal,
    $http
  ) {
    $scope.importBtnCollapsed = false
    $scope.currentUserInfo = JSON.parse(localStorage.user_info).user;
    $scope.select = {}
    $scope.treeConfig = {
        isCheckall: true,
        check: {
            //如果没有设置配置项，取默认配置
            enable: true, //显示不显示复选框
            chkboxType: { Y: '', N: '' },
        },
    }
    // 查询的参数
    $scope.queryParam = {
      pageSize: 10,
      pageNum: 1,
      param: {
        applyPeriod: utils.getQuarter(),
        state: '1',
      },
    }
    // 重置
    $scope.reset = function () {
      $scope.queryParam.param = {
        applyPeriod: utils.getQuarter(),
        state: '1',
      }
    //   queryInfo()
    getUserInfo()
    }
    // 选中的信息
    $scope.selectedRows = []
    //自动查询展示
    const queryInfo = function queryInfo() {
      const openLoading =
        $scope.queryParam.pageSize >= 100
          ? window.layer.msg('正在查询，请耐心等待', {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            })
          : null
      httpRequest
        .post_getSmallVatSbQueryList(queryDataHandle($scope.queryParam))
        .then((res) => {
          $scope.listData = res.data.value.list
          $scope.totalItems = res.data.value.total
          $scope.queryParam.pageNum = res.data.value.pageNum
          $scope.queryParam.pageSize = res.data.value.pageSize
          $scope.selectedRows = []
        })
        .finally(() => {
          window.layer.close(openLoading)
        })
    }
    function queryDataHandle(queryData) {
        $scope.employeeList = []
        const { selectedFollower } = $scope.select
        selectedFollower.forEach(item => {
            $scope.employeeList.push({employeeName:item.employeeName, employeeNumber:item.employeeNumber})
        });
        queryData.param.employeeList = $scope.employeeList

        return queryData
    }
    // 搜索
    $scope.searchList = function () {
      queryInfo()
    }
    // 分页
    $scope.pageChanged = function () {
      // 点击页码发起查询
      queryInfo()
    }
    // 改变税款所属月份
    $scope.updateSearch = function () {
      queryInfo()
    }
    //启用状态 字典
    $scope.dictData = {}
    const typecodeArrStr = [
      'glsale_declaration', //申报状态
      'department_no',
      'zzs_status',
    ]
    httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
      $scope.dictData = $.extend($scope.dictData, res.data.value)
    })
    // 主管税局省（市）
    httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
      $scope.dictDataProvince = res.data.value
    })
    // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
    httpRequest.get_getBelleRegion().then((res) => {
      $scope.belleRegionList = res.data.value
    })
    // 获取管理城市时两个都要传
    $scope.$watch('queryParam.param.regionName', function (newVal, oldVal) {
      //重置
      if ($scope.queryParam.param.regionName == '') {
        $scope.belleRegionCityList = []
        return
      }
      angular.forEach($scope.dictData.department_no, function (item, index) {
        if (item.enumName === $scope.queryParam.param.departmentNo) {
          $scope.departmentNo = item.enumCode
        }
      })
      angular.forEach($scope.belleRegionList, function (item, index) {
        if (item.regionName === newVal) {
          $scope.regionNo = item.treeLevelCode
        }
      })
      let params = {
        affiliation: $scope.departmentNo,
        regionNo: $scope.regionNo,
      }
      if (params.affiliation == '' || params.regionNo == '') return
      httpRequest.get_getBelleRegion(params).then((res) => {
        $scope.belleRegionCityList = res.data.value
      })
    })
    // queryInfo()
    $scope.queryInfo = queryInfo
    // 单个下载
    $scope.downloadFile = function (data) {
      if (data.mongoId == null) {
        logger.logError('申报表附件暂未生成，请稍后重试')
        return
      }
      if (Number(data.applyStatus) != 2 && Number(data.applyStatus) != 3) {
        logger.logError('申报状态为“申报成功”或"人工申报成功"的报表才允许下载，请检查')
        return
      }
      let applyPeriodTime = $scope.queryParam.param.applyPeriod
      let url = `${host.etcloudIvatApp}taxdeclaration/rpaStampDutyResult/downSbFile`
      let params = {
        sbDownListDtos: [
          {
            mongoId: data.mongoId,
            id: data.id,
            applyperiod: applyPeriodTime,
            taxNo: data.taxNo,
          },
        ],
      }
      let fileName = data.enclosure
      utils.declarefile_download(url, fileName, 'POST', 'blob', params, false)
    }
    // 批量下载
    $scope.batchDownload = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选择数据后操作')
      }
      //选择一个的时候单个下载
      if ($scope.selectedRows.length == 1) {
        $scope.downloadFile($scope.selectedRows[0])
        return
      }
      // // 可下载的集合
      $scope.newSelectedRows = []
      angular.forEach($scope.selectedRows, function (item, index) {
        if (
          (Number(item.applyStatus) == 2 || Number(item.applyStatus) == 3) &&
          item.mongoId != null
        ) {
          $scope.newSelectedRows.push(item)
        }
      })
      if ($scope.newSelectedRows.length == 0) {
        logger.logError('选择的数据暂时没有附件或申报状态不符合，请检查')
        return
      }
      let applyPeriod = $scope.queryParam.param.applyPeriod
      let resetFileName = '纳税申报表' + applyPeriod.replace('-', '')
      let params = {
        enclosure: resetFileName,
        sbDownListDtos: $scope.newSelectedRows,
      }
      let url = `${host.etcloudIvatApp}taxdeclaration/rpaStampDutyResult/downSbFile`
      utils.declarefile_download(url, resetFileName, 'POST', 'blob', params, true)
    }
    //导出
    $scope.exportExel = function exportExel() {
      let fileName = '申报任务查询(小规模)_' + $scope.queryParam.param.applyPeriod
      let url = `${
        host.etcloudIvatApp
      }taxdeclaration/sbSmallVatQuery/exportList?accessToken=${localStorage.getItem('id_token')}`
      utils.file_download(
        url,
        $scope.queryParam.param,
        '', //type
        'POST',
        'blob',
        fileName,
        false
      )
    }
    // 查询字段设置
    $scope.customizedConfig = {
      version: 5.5,
      queryConfig: [
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '申报状态',
          selected: true,
          default: true,
        },
        {
          label: '所属区域',
          selected: true,
          default: true,
        },
        {
          label: '管理城市',
          selected: true,
          default: true,
        },
        {
          label: '主管税局省（市）',
          selected: true,
          default: true,
        },
        {
          label: '事业部',
          selected: true,
          default: true,
        },
        {
          label: '是否开启申报',
          selected: true,
          default: true,
        },
        {
          label: '跟进人',
          selected: true,
          default: true,
        },
      ],
      table: [
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '事业部',
          selected: true,
          default: true,
        },
        {
          label: '所属区域',
          selected: true,
          default: true,
        },
        {
          label: '管理城市',
          selected: true,
          default: true,
        },
        {
          label: '主管税局省（市）',
          selected: true,
          default: true,
        },
        {
          label: '申报状态',
          selected: true,
          default: true,
        },
        {
          label: '应征增值税不含税销售额(3%征收率)',
          selected: true,
          default: true,
        },
        {
          label: '税务机关代开的增值税专用发票不含税销售额',
          selected: true,
          default: true,
        },
        {
          label: '税控器具开具的普通发票不含税销售额',
          selected: true,
          default: true,
        },
        {
          label: '免税销售额',
          selected: true,
          default: true,
        },
        {
          label: '其中:小微企业免税销售额',
          selected: true,
          default: true,
        },
        {
          label: '本期应纳税额减征额',
          selected: true,
          default: true,
        },
        {
          label: '应纳税额合计',
          selected: true,
          default: true,
        },
        {
          label: '本期应补(退)税额',
          selected: true,
          default: true,
        },
        {
          label: '应缴税款合计金额',
          selected: true,
          default: true,
        },
        {
          label: '城市维护建设税',
          selected: true,
          default: true,
        },
        {
          label: '教育费附加',
          selected: true,
          default: true,
        },
        {
          label: '地方教育附加',
          selected: true,
          default: true,
        },
        {
          label: '申报表附件',
          selected: true,
          default: true,
        },
        {
          label: '是否开启申报',
          selected: true,
          default: true,
        },
        {
          label: '跟进人',
          selected: true,
          default: true,
        },
      ],
    }
    function getUserInfo() {
        $scope.params = {
            pageSize: 2000,
            pageNum: 1,
            param: {
                isRoleOwner: '1', // 拥有本机构角色
                orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
            },
        }
        httpRequest.get_getIvatEmployeeList().then((res) => {
            $scope.followerList = dataHandle(res.data.value)
            $scope.select.selectedFollower =  $scope.followerList.filter((x) => { return x.employeeName == $scope.currentUserInfo.realName})
            queryInfo();
        })
    }
    getUserInfo()
    function dataHandle(list) {
        list.forEach((el,index) => {
            el.orgId = index
            el.orgName = el.employeeName + '|' + el.employeeNumber
            if ($scope.currentUserInfo.realName == el.employeeName) {
                el.checked = true
            } else {
                el.checked = false
            }
        })
        return list
    }
  }
}
smallScaleReportQueryCtrl.$inject = [
  '$scope',
  'httpRequest',
  '$state',
  '$stateParams',
  'sweetalert',
  'logger',
  'initSortService',
  '$timeout',
  'authService',
  '$filter',
  'Upload',
  '$uibModal',
  '$http',
]
export default smallScaleReportQueryCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxSmallScale/smallScaleReportQuery/smallScaleReportQueryCtrl.js